// extracted by mini-css-extract-plugin
module.exports = {"row":"ListRowPlaceholder_row__36D5q","placeholder":"ListRowPlaceholder_placeholder__bfLUB"};